import ApiClient from './ApiClient';

class SocialResponseTemplatesAPI extends ApiClient {
  constructor() {
    super('social_response_templates', { accountScoped: true });
  }

  getByInbox(inboxId) {
    return this.axios.get(`${this.url}`, {
      params: { inbox_id: inboxId },
    });
  }
}

export default new SocialResponseTemplatesAPI();
